import React, { Component } from 'react';
import { Link } from "gatsby"

class ShareLinks extends Component {
  constructor() {
    super();
    this.state = {
      isPreloaded: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isPreloaded: false });
    }, 100);
  }

  render() {
    const { twitterLink, facebookLink, linkedInLink, otherEditionLink, otherEditionText } = this.props;
    return (
            <>
              <nav className="main-actions-container">

                <div className="share-links-container">
                  <div>
                    <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                    </svg><span className="d-none d-sm-inline-block"> Share</span>
                  </div>
                  <a target="_blank" rel="noreferrer" href={ twitterLink }>
                   <svg className="svg-icon purple d-md-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>
                   <span className="d-none d-sm-inline-block ml-1 ml-md-0"> Twitter</span>
                  </a>
                  <a target="_blank" rel="noreferrer" href={ facebookLink }>
                    <svg className="svg-icon purple d-md-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg>
                    <span className="d-none d-sm-inline-block ml-1 ml-md-0"> Facebook</span>
                  </a>
                </div>

                <Link to="/editions" className="d-none d-md-block" style={{ textDecoration: 'none'}}>
                  <div className="btn btn-read-more py-3 mt-3">
                    <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" fill="currentColor">
                      <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                      </svg><span className="d-none d-sm-inline-block"> All editions</span>
                  </div>
                </Link>

              </nav>
            </>
    );
  }
}

export default ShareLinks;
